import { toString } from 'lodash'

export enum CurrencyEnum {
  cad = 'CAD',
  usd = 'USD'
}

export const numberToDollars = (value: number, locale = { region: 'en-US', currency: 'USD' }): string => {
  const formatter = new Intl.NumberFormat(locale.region, {
    style: 'currency',
    currency: locale.currency,
    minimumFractionDigits: 2
  })
  const trimNumber = trimDecimals(value, 2)
  return formatter.format(trimNumber)
}

const regionOtherThanCanada = 'en-US'
const numberToCanadianDollars = (value: number) =>
  numberToDollars(value, { region: regionOtherThanCanada, currency: 'CAD' })

export const numberToCurrency = (value: number, currency: CurrencyEnum) => {
  const formatters = {
    [CurrencyEnum.cad]: numberToCanadianDollars,
    [CurrencyEnum.usd]: numberToDollars
  }
  return formatters[currency](value)
}

export const trimDecimals = (number: number, limitAmount: number = 2) => {
  if (isNaN(number)) return number
  const money = toString(number).split('.')
  const dollars = money[0]
  const cents = money[1]?.length > 2 ? money[1].slice(0, limitAmount) : money[1] || '00'
  return Number(`${dollars}.${cents}`)
}

export const currencyStringToNumber = (value: string = ''): number => Number(value.replace(/[^0-9.-]+/g, ''))
